// Generated from Swagger on 2025-12-04T17:43:47.153Z

export enum ErrorEntity {
  DeactivatedByAdminForbidden = "DeactivatedByAdminForbidden",
  DeactivatedUserForbidden = "DeactivatedUserForbidden",
  DepartmentNotAllowedForbidden = "DepartmentNotAllowedForbidden",
  EMailNotVerifiedForbidden = "EMailNotVerifiedForbidden",
  InactiveSubscriptionForbidden = "InactiveSubscriptionForbidden",
  InactiveSubscriptionForbiddenException = "InactiveSubscriptionForbiddenException",
  IncompleteOnboardingIntroductionVideoForbidden = "IncompleteOnboardingIntroductionVideoForbidden",
  IncompleteOnboardingUserInvitationsForbidden = "IncompleteOnboardingUserInvitationsForbidden",
  InsufficientUserPermissionForbidden = "InsufficientUserPermissionForbidden",
  NoOrganizationForbidden = "NoOrganizationForbidden",
  NoUserFoundForbidden = "NoUserFoundForbidden",
  PaymentOverdueForbidden = "PaymentOverdueForbidden",
  NoBillingContractForbidden = "NoBillingContractForbidden",
  IncompleteProfileForbidden = "IncompleteProfileForbidden",
  BannedByAdminForbidden = "BannedByAdminForbidden",
}
